<h2 mat-dialog-title>
  <span *ngIf="mode === 'internal_comm'">
    {{ 'INTERNAL_COMM' | translate }}
  </span>
  <span *ngIf="mode === 'history'">
    <i class="fa fa-history" aria-hidden="true"></i> {{ 'HISTORY' | translate }}
  </span>
  <i class="far fa-times-circle medis-icon-large" mat-dialog-close></i>
</h2>
<mat-dialog-content *ngIf="interaction" class="history-content">
  <div class="medis-flex-container-between medis-pb-20" *ngIf="mode === 'history'">
    <div *ngIf="visualize === 'inquirer'">
      <span class="text-14-500-dark">
        <i class="fa fa-user"></i> @if(interaction.inquirer?.id){ {{ 'INQUIRER' | translate }}:
        <app-permission-edit [permissionName]="'View Enquirer'" showFallback class="d-inline-block">
          {{ interaction.inquirer | displayInfo }}
        </app-permission-edit>
        } @else {
        {{ 'NO_INQUIRER' | translate }}
        }
      </span>
    </div>
    <app-search-select
      *ngIf="visualize === 'interaction'"
      [config]="interactionConfig"
      [(selectedValue)]="selectedInteractionFilter"
      [multiple]="true"
    ></app-search-select>
    <div class="medis-toggle-group-wrapper medis-ml-10">
      <mat-button-toggle-group [(ngModel)]="visualize">
        <mat-button-toggle value="interaction">{{ 'INQUIRY' | translate }}</mat-button-toggle>
        <mat-button-toggle value="inquirer">{{ 'INQUIRER' | translate }}</mat-button-toggle>
      </mat-button-toggle-group>
    </div>
  </div>
  <div class="medis-flex-container-even medis-pb-20" *ngIf="mode === 'internal_comm' && !hideAdd">
    <button mat-button class="medis-button-main" (click)="openAddNote()">
      {{ 'ADD_A_NOTE' | translate }}
    </button>
  </div>
  <app-loading-indicator
    [loading]="isInquirerHistoryLoading || isInteractionHistoryLoading"
  ></app-loading-indicator>
  <app-message [message]="message"></app-message>
  <app-detail-history-interaction
    *ngIf="visualize == 'interaction'"
    [interaction]="interaction"
    [inquiry]="inquiry"
    [interactionFilter]="selectedInteractionFilter"
    [history]="interactionHistory"
    [mode]="mode"
    [loggedInUserIsSysAdmin]="loggedInUserIsSysAdmin"
  ></app-detail-history-interaction>
  <app-detail-history-inquirer
    *ngIf="visualize == 'inquirer'"
    [history]="inquirerHistory"
  ></app-detail-history-inquirer>
</mat-dialog-content>
